export class Constants{
    static MOBILE_WIDTH = 600;
    // Earth's circumference in miles
    static EARTH_CIRCUMFERENCE = 24888.84;
    // ToS document versions (match the effective date of the published terms text,
    // NOT the app release). Bumping a version re-triggers user consent.
    static TOS_VERSION = '2025-01-01';
    static BUSINESS_TOS_VERSION = '2026-07-06';
}
